import _classCallCheck from "/home/swarnim/practice/resume/masterPortfolio/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/swarnim/practice/resume/masterPortfolio/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/home/swarnim/practice/resume/masterPortfolio/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/* eslint-env browser */
var STYLES_HYDRATOR = /\.([^{:]+)(:[^{]+)?{(?:[^}]*;)?([^}]*?)}/g;
var KEYFRAMES_HYRDATOR = /@keyframes ([^{]+){((?:(?:from|to|(?:\d+\.?\d*%))\{(?:[^}])*})*)}/g;
var FONT_FACE_HYDRATOR = /@font-face\{font-family:([^;]+);([^}]*)\}/g;

function hydrateStyles(cache, hydrator, css) {
  var match;

  while (match = hydrator.exec(css)) {
    var _match = match,
        _match2 = _slicedToArray(_match, 4),
        id = _match2[1],
        pseudo = _match2[2],
        key = _match2[3];

    if (true && process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__) {
      hydrateDevtoolsRule(match[0]);
    }

    var fullKey = pseudo ? "".concat(pseudo).concat(key) : key;
    cache.cache[fullKey] = id; // set cache without triggering side effects

    cache.idGenerator.increment(); // increment id
  }
}

function hydrate(cache, hydrator, css) {
  var match;

  while (match = hydrator.exec(css)) {
    var _match3 = match,
        _match4 = _slicedToArray(_match3, 3),
        id = _match4[1],
        key = _match4[2];

    if (true && process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__) {
      hydrateDevtoolsRule(match[0]);
    }

    cache.cache[key] = id; // set cache without triggering side effects

    cache.idGenerator.increment(); // increment id
  }
}

import SequentialIDGenerator from "../sequential-id-generator";
import { Cache, MultiCache } from "../cache";
import injectStylePrefixed from "../inject-style-prefixed";
import { styleBlockToRule, atomicSelector, keyframesBlockToRule, declarationsToBlock, keyframesToBlock, fontFaceBlockToRule } from "../css";
import { insertRuleIntoDevtools, hydrateDevtoolsRule } from "../dev-tool";

var StyletronClient = /*#__PURE__*/function () {
  function StyletronClient() {
    var _this = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, StyletronClient);

    this.styleElements = {};
    var styleIdGenerator = new SequentialIDGenerator(opts.prefix);

    var onNewStyle = function onNewStyle(cache, id, value) {
      var pseudo = value.pseudo,
          block = value.block;
      var sheet = _this.styleElements[cache.key].sheet;
      var selector = atomicSelector(id, pseudo);
      var rule = styleBlockToRule(selector, block);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);

        if (true && process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__) {
          insertRuleIntoDevtools(selector, block);
        }
      } catch (e) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("Failed to inject CSS: \"".concat(rule, "\". Perhaps this has invalid or un-prefixed properties?"));
        }
      }
    }; // Setup style cache


    this.styleCache = new MultiCache(styleIdGenerator, function (media, _cache, insertBeforeMedia) {
      var styleElement = document.createElement("style");
      styleElement.media = media;

      if (insertBeforeMedia === void 0) {
        _this.container.appendChild(styleElement);
      } else {
        var insertBeforeIndex = findSheetIndexWithMedia(_this.container.children, insertBeforeMedia);

        _this.container.insertBefore(styleElement, _this.container.children[insertBeforeIndex]);
      }

      _this.styleElements[media] = styleElement;
    }, onNewStyle);
    this.keyframesCache = new Cache(new SequentialIDGenerator(opts.prefix), function (cache, id, value) {
      _this.styleCache.getCache("");

      var sheet = _this.styleElements[""].sheet;
      var rule = keyframesBlockToRule(id, keyframesToBlock(value));

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("Failed to inject CSS: \"".concat(rule, "\". Perhaps this has invalid or un-prefixed properties?"));
        }
      }
    });
    this.fontFaceCache = new Cache(new SequentialIDGenerator(opts.prefix), function (cache, id, value) {
      _this.styleCache.getCache("");

      var sheet = _this.styleElements[""].sheet;
      var rule = fontFaceBlockToRule(id, declarationsToBlock(value));

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("Failed to inject CSS: \"".concat(rule, "\". Perhaps this has invalid or un-prefixed properties?"));
        }
      }
    });

    if (opts.container) {
      this.container = opts.container;
    } // Hydrate


    if (opts.hydrate && opts.hydrate.length > 0) {
      // infer container from parent element
      if (!this.container) {
        var parentElement = opts.hydrate[0].parentElement;

        if (parentElement !== null && parentElement !== void 0) {
          this.container = parentElement;
        }
      }

      for (var i = 0; i < opts.hydrate.length; i++) {
        var element = opts.hydrate[i];
        var hydrateType = element.getAttribute("data-hydrate");

        if (hydrateType === "font-face") {
          hydrate(this.fontFaceCache, FONT_FACE_HYDRATOR, element.textContent);
          continue;
        }

        if (hydrateType === "keyframes") {
          hydrate(this.keyframesCache, KEYFRAMES_HYRDATOR, element.textContent);
          continue;
        }

        var key = element.media ? element.media : "";
        this.styleElements[key] = element;
        var cache = new Cache(styleIdGenerator, onNewStyle);
        cache.key = key;
        hydrateStyles(cache, STYLES_HYDRATOR, element.textContent);
        this.styleCache.sortedCacheKeys.push(key);
        this.styleCache.caches[key] = cache;
      }
    }

    if (!this.container) {
      if (document.head === null) {
        throw new Error("No container provided and `document.head` was null");
      }

      this.container = document.head;
    }
  }

  _createClass(StyletronClient, [{
    key: "renderStyle",
    value: function renderStyle(style) {
      return injectStylePrefixed(this.styleCache, style, "", "");
    }
  }, {
    key: "renderFontFace",
    value: function renderFontFace(fontFace) {
      var key = declarationsToBlock(fontFace);
      return this.fontFaceCache.addValue(key, fontFace);
    }
  }, {
    key: "renderKeyframes",
    value: function renderKeyframes(keyframes) {
      var key = keyframesToBlock(keyframes);
      return this.keyframesCache.addValue(key, keyframes);
    }
  }]);

  return StyletronClient;
}();

export default StyletronClient;

function findSheetIndexWithMedia(children, media) {
  var index = 0;

  for (; index < children.length; index++) {
    var child = children[index];

    if (child.tagName === "STYLE" && child.media === media) {
      return index;
    }
  }

  return -1;
}